import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import ActiveBugReports from '../active-bug-reports/ActiveBugReports';
import ArchivedBugReports from '../archived-bug-reports/ArchivedBugReports';
import { Paths } from '../../../shared/paths';
import BugReport from '../bug-report/BugReport';

export function BugReportsInnerTabs() {
  const { t } = useTranslation();
  const base = Paths.moderatorDashboard.bugReports();

  const tabsConfig = useMemo(
    () => [
      {
        label: t('adminDashboard.support.tabs.active'),
        path: `${base}/list/active`,
      },
      {
        label: t('adminDashboard.support.tabs.archived'),
        path: `${base}/list/archived`,
      },
    ],
    [base, t],
  );

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          <Route path="list/active" element={<ActiveBugReports />} />
          <Route path="list/active/report/:reportId" element={<BugReport />} />
          <Route path="list/archived" element={<ArchivedBugReports />} />
          <Route
            path="list/archived/report/:reportId"
            element={<BugReport />}
          />
          <Route
            path="active"
            element={<Navigate to="../list/active" replace />}
          />
          <Route
            path="archived"
            element={<Navigate to="../list/archived" replace />}
          />
          <Route index element={<Navigate to="list/active" replace />} />
          <Route path="*" element={<Navigate to="list/active" replace />} />
        </Routes>
      </Box>
    </>
  );
}
